import { Stack, ToggleButton } from '@mui/material'
import { TpToggleButtonGroup } from '~/components/tp-toggle-button-group'
import { TpTooltip } from '~/components'
import { useCropModalContext } from '../context/crop-modal-context'
import { SELECT_CROP_TOOLTIP_TEXT } from '../constants/crop-modal-constants'

export const CropTypeToggles = ({
  availableCropPropagationTypes,
  cropLifecycleTypes,
  cropGrowthTypes,
  activePropagationCode,
  onPropagationChange,
  onLifecycleChange,
  onGrowthChange,
}) => {
  const { species, lifecycleType, growthType, isCustomCrop } = useCropModalContext()

  return (
    <Stack
      sx={{
        display: 'grid',
        gridTemplateColumns: isCustomCrop ? '1fr' : { xs: '1fr', xl: 'repeat(2, 1fr)' },
        gap: 1,
        rowGap: 0.5,
        justifyItems: { xs: 'center', sm: 'flex-end' },
        '& > *:last-child:nth-of-type(odd)': {
          gridColumn: { xl: 2 },
        },
      }}
    >
      <TpTooltip followCursor placement='top' title={(!species && !isCustomCrop) ? SELECT_CROP_TOOLTIP_TEXT : ''}>
        <TpToggleButtonGroup
          value={activePropagationCode}
          exclusive
          onChange={(e, newValue) => newValue && onPropagationChange(newValue)}
          disabled={!species && !isCustomCrop}
        >
          {availableCropPropagationTypes.map(({ code, method, description }) => (
            <TpTooltip key={code} title={description} enterDelay={500} followCursor>
              <ToggleButton value={code}>{method}</ToggleButton>
            </TpTooltip>
          ))}
        </TpToggleButtonGroup>
      </TpTooltip>

      <TpTooltip followCursor placement='top' title={(!species && !isCustomCrop) ? SELECT_CROP_TOOLTIP_TEXT : ''}>
        <TpToggleButtonGroup
          value={lifecycleType}
          exclusive
          onChange={(e, newValue) => newValue && onLifecycleChange(newValue)}
          disabled={!species && !isCustomCrop}
        >
          {cropLifecycleTypes.map(({ code, name, description }) => (
            <TpTooltip key={code} title={description} enterDelay={500} followCursor>
              <ToggleButton value={code}>{name}</ToggleButton>
            </TpTooltip>
          ))}
        </TpToggleButtonGroup>
      </TpTooltip>

      <TpTooltip followCursor placement='top' title={(!species && !isCustomCrop) ? SELECT_CROP_TOOLTIP_TEXT : ''}>
        <TpToggleButtonGroup
          value={growthType}
          exclusive
          onChange={(e, newValue) => newValue && onGrowthChange(newValue)}
          disabled={!species && !isCustomCrop}
        >
          {cropGrowthTypes.map(({ code, name, description }) => (
            <TpTooltip key={code} title={description} enterDelay={500} followCursor>
              <ToggleButton value={code}>{name}</ToggleButton>
            </TpTooltip>
          ))}
        </TpToggleButtonGroup>
      </TpTooltip>
    </Stack>
  )
}
